module.exports = __webpack_public_path__ + "media/images/new_home/discover-1-339666d857b23e7e464f61b3ed0cb2a7.png";